var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 0C49.7025 0 60 10.2975 60 23V37C60 49.7025 49.7025 60 37 60H23C10.2975 60 0 49.7025 0 37V23C0 10.2975 10.2975 0 23 0H37Z",
    fill: "#E9EFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    d: "M37.9998 24.667C40.2089 24.667 41.9998 26.4579 41.9998 28.667C41.9996 30.876 40.2088 32.667 37.9998 32.667C35.7909 32.6668 33.9999 30.8759 33.9998 28.667C33.9998 26.458 35.7908 24.6672 37.9998 24.667ZM25.9998 18C28.9452 18 31.3336 20.3876 31.3337 23.333C31.3337 26.2785 28.9453 28.667 25.9998 28.667C23.0544 28.6668 20.6667 26.2784 20.6667 23.333C20.6669 20.3877 23.0545 18.0002 25.9998 18Z",
    fill: "#2563EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9775 31.3334C32.3612 31.3334 37.6062 34.3908 37.9971 40.933C38.0126 41.1936 37.9967 42.0004 36.9951 42.0004H14.9697C14.6353 42 13.9728 41.2785 14.001 40.932C14.5179 34.5687 19.6825 31.3335 25.9775 31.3334ZM37.4688 34.0023C42.0104 34.0521 45.7188 36.3469 45.998 41.1996C46.0093 41.3951 45.9978 42.0004 45.2744 42.0004H40.1338C40.1338 38.9996 39.1417 36.2304 37.4688 34.0023Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDashboard);
export default __webpack_public_path__ + "static/media/studentDashboard.acb472abfeec4aee5eaf844eec691daf.svg";
export { ForwardRef as ReactComponent };